var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import Dropdown from '@/components/Dropdown.vue';
import apiGateway, { ProjectCategory } from '@/api-gateway';
import vSelect from 'vue-select';
import { DynamicSelectBox } from '@/components/dynamic-select';
var SubFilter = /** @class */ (function (_super) {
    __extends(SubFilter, _super);
    function SubFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.projectCategories = [];
        _this.selectedProjectCategory = '';
        _this.formatOptions = [];
        _this.selectedFormatOptions = '';
        _this.projectRegionCode = [];
        _this.selectedProjectRegionCode = [];
        _this.programDropdown = {
            projectCategory: '',
            formatOptions: '',
            projectRegionCode: [],
            projectOwner: null,
            projectManager: null,
            userProjectManager: []
        };
        _this.showFormat = false;
        _this.showRegion = false;
        _this.usersData = [];
        _this.selectedProjectOwner = null;
        _this.selectedProjectManager = null;
        _this.class_witdh_1 = 'w-full sm:w-full md:w-1/3 lg:w-1/4 xl:w-1/5 mb-4';
        _this.class_witdh_2 = 'w-full sm:w-full md:w-1/4 lg:w-1/4 xl:w-1/6 mb-4';
        return _this;
    }
    Object.defineProperty(SubFilter.prototype, "dashboardName", {
        get: function () {
            return this.dashboardType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubFilter.prototype, "allUsers", {
        get: function () {
            return this.usersData.map(function (user) { return ({
                value: user.id.toString(),
                text: user.firstname + " " + user.lastname
            }); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubFilter.prototype, "userProjectManage", {
        get: function () {
            var userProjectManage = [];
            var userIds = [];
            this.usersData.forEach(function (user) {
                var _a, _b;
                var positions = (_b = (_a = user.position) === null || _a === void 0 ? void 0 : _a.split(', ')) !== null && _b !== void 0 ? _b : [];
                positions === null || positions === void 0 ? void 0 : positions.forEach(function (position) {
                    if (position === 'Construction') {
                        var users = {
                            value: user.id.toString(),
                            text: user.firstname + " " + user.lastname
                        };
                        userProjectManage.push(users);
                        userIds.push(user.id);
                    }
                });
            });
            this.programDropdown.userProjectManager = userIds;
            return userProjectManage;
        },
        enumerable: false,
        configurable: true
    });
    SubFilter.prototype.getCategories = function () {
        this.projectCategories = [
            { text: 'Select a Project Category', value: '' },
            { text: 'New store', value: ProjectCategory.NEWSTORE },
            { text: 'Rebrand+/Refresh', value: ProjectCategory.REBRANDING },
            { text: 'Planning/Mall', value: ProjectCategory.PLANNINGANDMALL },
            { text: 'FM', value: ProjectCategory.FM }
        ];
    };
    SubFilter.prototype.getFormats = function () {
        return __awaiter(this, void 0, Promise, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiGateway.getMyFormats()];
                    case 1:
                        resp = _a.sent();
                        this.formatOptions = resp.data.map(function (item) { return ({
                            text: item.name,
                            value: item.id.toString()
                        }); }) || [];
                        this.formatOptions.unshift({ text: 'Select a Format', value: '' });
                        return [2 /*return*/];
                }
            });
        });
    };
    SubFilter.prototype.getProjectRegionCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formatOption, resp, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        formatOption = parseInt(this.selectedFormatOptions);
                        return [4 /*yield*/, apiGateway.getProjectRegionCode(2)];
                    case 1:
                        resp = _a.sent();
                        this.projectRegionCode = resp.data.map(function (item) {
                            return item.name;
                        }) || [];
                        this.projectRegionCode.unshift('ALL');
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SubFilter.prototype.fetchUsers = function () {
        return __awaiter(this, void 0, Promise, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiGateway.getUsers()];
                    case 1:
                        resp = _a.sent();
                        this.usersData = resp.data || [];
                        return [2 /*return*/];
                }
            });
        });
    };
    SubFilter.prototype.setDropdownByCategory = function () {
        switch (this.selectedProjectCategory) {
            case ProjectCategory.NEWSTORE:
            case ProjectCategory.REBRANDING:
                this.showFormat = true;
                break;
            default:
                this.showFormat = false;
                this.showRegion = false;
                this.selectedFormatOptions = '';
                this.selectedProjectRegionCode = [];
                this.programDropdown.formatOptions = '';
                this.programDropdown.projectRegionCode = [];
        }
    };
    SubFilter.prototype.setDropdownByFormat = function () {
        switch (this.selectedFormatOptions) {
            case '2':
                this.showRegion = true;
                break;
            default:
                this.showRegion = false;
                this.selectedProjectRegionCode = [];
                this.programDropdown.projectRegionCode = [];
        }
    };
    SubFilter.prototype.handleOwnersUpdated = function (ids) {
        this.stringOwnerIds = ids;
    };
    SubFilter.prototype.setClassDropdown = function () {
        if (this.scale === '3/4') {
            this.class_witdh_1 = 'w-full sm:w-full md:w-full lg:w-1/3 xl:w-1/3 mb-4';
            this.class_witdh_2 = 'w-full sm:w-full md:w-full lg:w-1/3 xl:w-1/4 mb-4';
        }
    };
    SubFilter.prototype.projecetCategoryChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.programDropdown.projectCategory = this.selectedProjectCategory;
                        return [4 /*yield*/, this.setDropdownByCategory()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.outputValue()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SubFilter.prototype.projectFormatChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.programDropdown.formatOptions = this.selectedFormatOptions;
                        return [4 /*yield*/, this.setDropdownByFormat()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getProjectRegionCode()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.outputValue()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SubFilter.prototype.projectRegionCodeChange = function () {
        this.programDropdown.projectRegionCode = this.selectedProjectRegionCode;
        this.outputValue();
    };
    SubFilter.prototype.genDropdownProjectOwener = function () {
        var _a;
        if ((_a = this.selectedProjectOwner) === null || _a === void 0 ? void 0 : _a.value) {
            this.programDropdown.projectOwner = this.selectedProjectOwner.value;
        }
        else {
            this.programDropdown.projectOwner = null;
        }
        this.outputValue();
    };
    SubFilter.prototype.genDropdownProjectManager = function () {
        var _a;
        if ((_a = this.selectedProjectManager) === null || _a === void 0 ? void 0 : _a.value) {
            this.programDropdown.projectManager = this.selectedProjectManager.value;
        }
        else {
            this.programDropdown.projectManager = null;
        }
        this.outputValue();
    };
    SubFilter.prototype.outputValue = function () {
        return this.programDropdown;
    };
    SubFilter.prototype.beforeMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setClassDropdown();
                        return [4 /*yield*/, Promise.all([
                                this.getCategories(),
                                this.getFormats(),
                                this.outputValue(),
                                this.fetchUsers()
                            ])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({
            type: Number
        })
    ], SubFilter.prototype, "programId", void 0);
    __decorate([
        Prop({
            type: String
        })
    ], SubFilter.prototype, "dashboardType", void 0);
    __decorate([
        Prop({
            type: String
        })
    ], SubFilter.prototype, "scale", void 0);
    __decorate([
        Watch('selectedProjectOwner')
    ], SubFilter.prototype, "genDropdownProjectOwener", null);
    __decorate([
        Watch('selectedProjectManager')
    ], SubFilter.prototype, "genDropdownProjectManager", null);
    __decorate([
        Emit('output')
    ], SubFilter.prototype, "outputValue", null);
    SubFilter = __decorate([
        Component({
            components: {
                Dropdown: Dropdown,
                vSelect: vSelect,
                DynamicSelectBox: DynamicSelectBox
            }
        })
    ], SubFilter);
    return SubFilter;
}(Vue));
export default SubFilter;
